module.exports = __webpack_public_path__ + "media/images/site/erica-aponta-camiseta-1f4d3d64cbe8e44cb008dbb1f0cff206.png";